import Vue from "vue";

const defaultEvent = {
  title: "",
  agenda: "",
  location: "",
  allDay: false,
  start: 0,
  end: 0,
  color: "#00ACC1",
  users: [],
  courses: [],
  klasses: [],
  schools: []
};

export default {
  namespaced: true,
  state: {
    events: [],
    showActiveEvent: false,
    editEvent: { ...defaultEvent },
    showAddEventDialog: false,
    editEventUpdate: false,
    selected: {
      schools: [],
      klasses: [],
      courses: [],
      personnel: []
    }
  },
  mutations: {
    toggleAddEventDialog(state, val) {
      state.showAddEventDialog = val
      this.commit('calendar/triggerEditEventUpdate')
    },
    triggerEditEventUpdate(state) {
      if (state.showAddEventDialog) {
        state.showAddEventDialog = false
        state.showAddEventDialog = true
      }
      state.editEventUpdate = !state.editEventUpdate
    },
    setEvents(state, events) {
      state.events = events;
    },
    appendEvents(state, events) {
      for (let event of events) {
        state.events.push(event)
      }
    },
    addNewEvent(state, event) {
      state.events.push(event)
    },
    removeEvent(state, event) {
      const i = state.events.findIndex(e => e.id == event.id);
      if (~i) {
        Vue.delete(state.events, i);
      }
    },
    updateEditEvent(state, props) {
      for (let p in props) {
        Vue.set(state.editEvent, p, props[p])
      }
    },
    setEditEvent(state, event) {
      this.commit('calendar/resetEditEvent')
      for (let key in event) {
        if (key == 'users') {
          for (let i = 0; i < event.users.length; ++i) {
            const foundUser = this.state.users.find(u => u.id == event.users[i].id);
            if (foundUser) {
              event.users[i] = foundUser;
            }
          }
        }
        Vue.set(state.editEvent, key, event[key]);
      }
    },
    resetEditEvent(state) {
      state.editEvent = { ...defaultEvent };
      const me = this.state.user.loggedInUser;
      if (me && me.id) {
        state.editEvent.users = [me]
      }
    },
    updateSelected(state, val) {
      for (let key in val) {
        Vue.set(state.selected, key, val[key]);
      }
    },
    setActiveEvent(state, event) {
      state.activeEvent = { ...event }
    },
    toggleActiveEvent(state, val) {
      state.showActiveEvent = val
    }
  }
};
